import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';

const LoginPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isLogin) {
        await login(email, password);
        toast.success('Sėkmingai prisijungta!');
      } else {
        await register(email, password, fullName);
        toast.success('Paskyra sukurta sėkmingai!');
      }
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Klaida. Bandykite dar kartą.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] flex items-center justify-center py-20">
      <div className="container mx-auto px-4 max-w-md">
        <div className="bg-white rounded-3xl shadow-xl border border-slate-100 p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-['Poppins'] font-bold text-slate-900 mb-2">
              {isLogin ? 'Prisijungti' : 'Registruotis'}
            </h1>
            <p className="text-slate-600">
              {isLogin ? 'Prisijunkite prie savo paskyros' : 'Sukurkite naują paskyrą'}
            </p>
          </div>

          <form onSubmit={handleSubmit} data-testid="auth-form" className="space-y-6">
            {!isLogin && (
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  Vardas ir Pavardė
                </label>
                <input
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required={!isLogin}
                  data-testid="fullname-input"
                  className="w-full h-12 rounded-xl border border-slate-200 px-4 focus:outline-none focus:border-[#00C49A] focus:ring-2 focus:ring-[#00C49A]/20 transition-colors"
                  placeholder="Jonas Jonaitis"
                />
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                El. paštas
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="email-input"
                  className="w-full h-12 rounded-xl border border-slate-200 pl-11 pr-4 focus:outline-none focus:border-[#00C49A] focus:ring-2 focus:ring-[#00C49A]/20 transition-colors"
                  placeholder="jusu@pastas.lt"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Slaptažodis
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="password-input"
                  className="w-full h-12 rounded-xl border border-slate-200 pl-11 pr-11 focus:outline-none focus:border-[#00C49A] focus:ring-2 focus:ring-[#00C49A]/20 transition-colors"
                  placeholder="••••••••"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="submit-button"
              className="w-full bg-[#00C49A] text-white hover:bg-[#059669] rounded-full h-12 font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Kraunasi...' : (isLogin ? 'Prisijungti' : 'Registruotis')}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => setIsLogin(!isLogin)}
              data-testid="toggle-auth-mode"
              className="text-[#00C49A] hover:text-[#059669] font-medium"
            >
              {isLogin ? 'Neturite paskyros? Registruokis' : 'Jau turite paskyrą? Prisijunkite'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;